import { API } from "../api";

const BASE = "/cooperatives/payments/bank-transfers";

export const bankTransferAdminApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getStaffBankTransferPayments: builder.query({
      query: ({ status = "pending", search = "", page = 1, limit = 20 }) => {
        const params = new URLSearchParams({
          guard: "staff",
          status: String(status),
          page: String(page),
          limit: String(limit),
        });
        if (search) params.append("search", search);
        return { url: `${BASE}?${params.toString()}` };
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "bank-transfer-payments", id: "list" }],
    }),

    getStaffBankTransferPaymentDetail: builder.query({
      query: (id) => ({
        url: `${BASE}/${id}?guard=staff`,
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, id) => [
        { type: "bank-transfer-payments", id: String(id) },
      ],
    }),

    confirmStaffBankTransferPayment: builder.mutation({
      query: ({ id, acknowledgement }) => ({
        url: `${BASE}/${id}/confirm?guard=staff`,
        method: "POST",
        body: { acknowledgement },
      }),
      invalidatesTags: [
        { type: "bank-transfer-payments" },
        { type: "member-contributions-history" },
        { type: "member-contributions-summary" },
        { type: "member-loan-summary" },
        { type: "member-upcoming-repayment-list" },
        { type: "member-due-repayment-list" },
        { type: "member-overdue-repayment-list" },
        { type: "member-transaction-history" },
        "MemberAttendance",
        { type: "member-bank-transfer-payments" },
        "StaffDashboard",
      ],
    }),

    rejectStaffBankTransferPayment: builder.mutation({
      query: ({ id, reason }) => ({
        url: `${BASE}/${id}/reject?guard=staff`,
        method: "POST",
        body: { reason },
      }),
      invalidatesTags: [
        { type: "bank-transfer-payments" },
        { type: "member-bank-transfer-payments" },
      ],
    }),
  }),
});

export const {
  useGetStaffBankTransferPaymentsQuery,
  useGetStaffBankTransferPaymentDetailQuery,
  useConfirmStaffBankTransferPaymentMutation,
  useRejectStaffBankTransferPaymentMutation,
} = bankTransferAdminApi;
